import { render, staticRenderFns } from "./groups-top-bar-playlists.vue?vue&type=template&id=46c652a2&scoped=true&"
import script from "./groups-top-bar-playlists.vue?vue&type=script&lang=js&"
export * from "./groups-top-bar-playlists.vue?vue&type=script&lang=js&"
import style0 from "./groups-top-bar-playlists.vue?vue&type=style&index=0&id=46c652a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c652a2",
  null
  
)

export default component.exports